var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      attrs: {
        href: "javascript:0;",
        "data-toggle": "popover",
        title: "Obligatorische Nebenkosten",
        "data-trigger": "hover",
        "data-placement": "top",
        "data-html": "true",
        "data-content": _vm.getPriceText
      }
    },
    [_c("i", { staticClass: "fas fa-question-circle pricehelp" })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }